import * as React from 'react';
import TextField from '@mui/material/TextField';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {esES} from "@mui/x-date-pickers";

export const DatePickerCustomed = ((props) => (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es-ES' localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}>
      <DatePicker
        label="Fecha"
        inputFormat="MM/DD/YYYY"
        {...props}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  ));